import React from 'react';
import { MapPin, Phone, MessageCircle, IndianRupee } from 'lucide-react';
import './ServiceCard.css';

const ServiceCard = ({ service, onClick }) => {
  const handlePhoneClick = (e) => {
    e.stopPropagation();
    // Copy to clipboard
    navigator.clipboard.writeText(service.phoneNumber);
    // Redirect to phone call
    window.location.href = `tel:+91${service.phoneNumber}`;
  };

  const handleWhatsAppClick = (e) => {
    e.stopPropagation();
    const message = encodeURIComponent(`Hi, I found your service "${service.title}" on TravelB2B Hub. I'd like to know more.`);
    window.open(`https://wa.me/91${service.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="service-card" onClick={onClick}>
      <div className="service-card-header">
        <span className="service-category">{service.category}</span>
        {service.price && (
          <span className="service-price">
            <IndianRupee size={14} />
            {service.price}
          </span>
        )}
      </div>

      <div className="service-company">
        <span className="company-name">{service.companyName}</span>
      </div>

      <h3 className="service-title">{service.title}</h3>

      <p className="service-description">
        {service.description}
      </p>

      {(service.city || service.state || service.location) && (
        <div className="service-location">
          <MapPin size={16} />
          <span>{service.city ? `${service.city}, ${service.state}` : service.location}</span>
        </div>
      )}

      <div className="service-actions">
        <button
          className="action-btn action-btn-phone"
          onClick={handlePhoneClick}
          title="Call now"
        >
          <Phone size={18} />
          <span>Call</span>
        </button>
        <button
          className="action-btn action-btn-whatsapp"
          onClick={handleWhatsAppClick}
          title="Chat on WhatsApp"
        >
          <MessageCircle size={18} />
          <span>WhatsApp</span>
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;

